const baseURL = 'https://develop.trios.com.vn/dev/v1';

export { baseURL };